import { IconVariant } from "@/components/atoms";
import { QuickSetupModal, WhyExplanation } from "./QuickSetupModal";

interface WhyDoINeedModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  explanations: WhyExplanation[];
  featuredIcon?: {
    name: string;
    background?: string;
    className?: string;
    isCustom?: boolean;
    variant?: IconVariant;
  };
}

export const WhyDoINeedModal = ({ open, onClose, title, subtitle, explanations, featuredIcon }: WhyDoINeedModalProps) => {
  return (
    <QuickSetupModal
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      variant="web-small"
      featuredIcon={featuredIcon}
      content={{
        type: "why",
        explanations,
      }}
    />
  );
};
